import { useCallback, useState } from 'react';

const useToggleState = (initalState = false) => {
	const [value, toggle] = useState<boolean>(initalState);
	const toggleState = useCallback(() => {
		toggle((prevState) => !prevState);
	}, [toggle]);

	return [value, toggleState] as const;
};

export default useToggleState;
